import { RASHI_NAMES } from '@astrally/shared';
import { useI18n } from '../../i18n';
import { polar, ringSegment } from './geometry';

/**
 * The twelve rashis as a ring: numbered 1-12, Indian names, Mesha highlighted
 * as the traditional start of the count. Purely schematic — no chart data.
 */

const CX = 170;
const CY = 170;
const R_OUT = 150;
const R_IN = 96;
const R_LABEL = (R_OUT + R_IN) / 2;

export function RashiWheel() {
  const { t } = useI18n();
  return (
    <svg
      viewBox="0 0 340 362"
      style={{ width: '100%', height: 'auto' }}
      role="img"
      aria-label={t('learn.fig.rashiWheel.alt')}
    >
      {RASHI_NAMES.map((name, i) => {
        const a0 = i * 30;
        const a1 = a0 + 30;
        const [nx, ny] = polar(CX, CY, R_LABEL, a0 + 15);
        return (
          <g key={name}>
            <path
              d={ringSegment(CX, CY, R_OUT, R_IN, a0, a1)}
              fill={i === 0 ? 'var(--mode-soft)' : 'transparent'}
              stroke="var(--border-strong)"
              strokeWidth="1"
            />
            <text
              x={nx}
              y={ny - 2}
              textAnchor="middle"
              fontSize="12"
              fontWeight="700"
              fill={i === 0 ? 'var(--mode-ink)' : 'var(--text)'}
            >
              {i + 1}
            </text>
            <text x={nx} y={ny + 11} textAnchor="middle" fontSize="9" fill="var(--text-dim)">
              {name}
            </text>
          </g>
        );
      })}
      {/* The Mesha/Meena boundary — where the count begins. */}
      <line
        x1={polar(CX, CY, R_IN - 4, 0)[0]}
        y1={polar(CX, CY, R_IN - 4, 0)[1]}
        x2={polar(CX, CY, R_OUT + 4, 0)[0]}
        y2={polar(CX, CY, R_OUT + 4, 0)[1]}
        stroke="var(--mode)"
        strokeWidth="2"
      />
      <text
        x={CX}
        y={CY - 6}
        textAnchor="middle"
        fontSize="12"
        fontWeight="600"
        fill="var(--text-dim)"
      >
        {t('learn.fig.rashiWheel.center1')}
      </text>
      <text x={CX} y={CY + 12} textAnchor="middle" fontSize="10" fill="var(--text-faint)">
        {t('learn.fig.rashiWheel.center2')}
      </text>
      <text x={CX} y={352} textAnchor="middle" fontSize="10" fill="var(--text-dim)">
        {t('learn.fig.rashiWheel.note')}
      </text>
    </svg>
  );
}
